import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
const ADD_LEONARDO_RESOURCE_PATH = BASE_PATH + "/add-leonardo-resource";
export const addLeonardoResource = async (url) => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    headers.set("Content-Type", "application/json");
    return fetch(ADD_LEONARDO_RESOURCE_PATH, {
        method: "POST",
        headers,
        body: JSON.stringify({ url }),
    }).then((response) => {
        if (response.status === 200) {
            return true;
        }
        else {
            return false;
        }
    });
};
